// NO_MODIFY_THIS_FILE_BAKKA
import * as actions from './actions';
import * as api from './api';
import bookingReducer from './booking.reducer';
import * as functions from './functions';
import activityReducer from './reducer';

const reducers = {
  activityBooking: bookingReducer,
  activityData: activityReducer,
};

export {
 actions, api, functions, reducers,
};
